export default "__VITE_ASSET__B8Df7Twm__"